module.exports = __webpack_public_path__ + "6f36e750229b503f07193fa7c40d45b5.svg";